import { orgSelectors } from 'ducks/orgs'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import PostCheckoutPage from './checkout/PostCheckoutPage'
import OutletOrderConfirmationPage from './checkout/solarOutlet/OutletOrderConfirmationPage'

const OrderConfirmationPage = (props) => {
  const supplier = useSelector(orgSelectors.getSelectedHardwareSupplier)
  const orderId = props?.match?.params?.orderId

  switch (supplier) {
    case 'outlet':
      return <OutletOrderConfirmationPage orderId={orderId} />
    case 'city_plumbing':
      return <PostCheckoutPage distributor={'city_plumbing'} orderId={orderId} quoteOrOrderType={'order'} />
    default:
      return null
  }
}

export default memo(OrderConfirmationPage)
